module.exports = __webpack_public_path__ + "img/top-banner-image-m.767a2533.png";